module.exports = __webpack_public_path__ + "img/13.e51869ba.jpg";